import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../axiosConfig"; // Import global Axios instance
import "./Header.css";
import { ReactComponent as Logo } from "../../assets/logolarge.svg";

const Header = ({ onUserLoad }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkIfLoggedIn = async () => {
      try {
        const response = await axios.get("/api/session/");
        console.log("User authenticated:", response.data);
        setUser(response.data.user);
        onUserLoad(response.data.user); // Pass user up to parent
      } catch (error) {
        console.log("User is not logged in:", error.response?.data?.error || error.message);
        navigate("/login"); // Redirect to login if not authenticated
      } finally {
        setLoading(false);
      }
    };

    checkIfLoggedIn();
  }, [navigate, onUserLoad]);

  const handleLogout = async () => {
    try {
      await axios.post("/api/logout/", {}, { withCredentials: true });
      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error.response?.data?.error || error.message);
    }
  };

  if (loading) {
    return <p>Checking authentication...</p>; // Prevent rendering pages before checking auth
  }

  return (
    <div className="header">
      <div className="header-content">
        <a href="https://portal.perldbase.com">
          <Logo className="header-img" />
        </a>
        <div className="user-info">
          <p>{user?.email}</p>
          <button onClick={handleLogout}>Log Out</button>
        </div>
      </div>
    </div>
  );
};

export default Header;
